import React from "react";
import { Box, Typography } from "@mui/material";
import CrossConnectionForm from "../../components/common/form/CrossConnectionForm";

export default function CrossConnectionPage() {
  return (
    <Box p={4}>
      <Typography variant="h6" gutterBottom>
        Cross Connection erfassen
      </Typography>
      <CrossConnectionForm />
    </Box>
  );
}
